import noop from 'lodash/noop';

import { DialogComponent } from '@/components/DialogComponent';

import { QUIZ_PLAYER_BOTTOMSHEET_CLASSES, QUIZ_PLAYER_DIALOG_CLASSES } from './styles';

interface Props {
  children: React.ReactNode;
}

const QuizPlayerDialog: React.FC<Props> = ({ children }) => {
  return (
    <DialogComponent
      open
      bottomSheetClasses={QUIZ_PLAYER_BOTTOMSHEET_CLASSES}
      bottomSheetContainerClassName="h-full overflow-hidden"
      classes={QUIZ_PLAYER_DIALOG_CLASSES}
      showCloseIcon={false}
      onClose={noop}>
      {children}
    </DialogComponent>
  );
};

export default QuizPlayerDialog;
